import { render, staticRenderFns } from "./zfb-payment.vue?vue&type=template&id=31e6403e&scoped=true"
import script from "./zfb-payment.vue?vue&type=script&lang=js"
export * from "./zfb-payment.vue?vue&type=script&lang=js"
import style0 from "./style/payment.scss?vue&type=style&index=0&id=31e6403e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e6403e",
  null
  
)

export default component.exports